export default __webpack_public_path__ + "static/media/box.bf088d69.svg";